export default function PHP_intval() {
  return (
    <div>
      <h1>PHP_intval</h1>
    </div>
  );
}
